/**
 * this tinyMCE version is here and not part of the package.json because it is not a module
 * tinyMCE makes lots of trouble with self-hosting so next developer who needs to handle new version on new plugin good luck
 */

import './tinymce.min.js';
import './icons/default/icons.min.js';
import './themes/silver/theme.min.js';
import './models/dom/model.min.js';

import './plugins/autoresize/plugin.min.js';
import './plugins/link/plugin.min.js';
import './plugins/lists/plugin.min.js';
import './plugins/code/plugin.min.js';
import './plugins/directionality/plugin.min.js';

import TextEditor from '@tinymce/tinymce-vue';

export default TextEditor;
